'use client';

import { motion } from 'framer-motion';
import { ReactNode, useEffect, useState } from 'react';

interface AnimatedGradientBackgroundProps {
  children: ReactNode;
  isFullPage?: boolean;
  animateOnEnter?: boolean;
}

export function AnimatedGradientBackground({ 
  children, 
  isFullPage = false,
  animateOnEnter = false,
}: AnimatedGradientBackgroundProps) {
  const [shouldAnimate, setShouldAnimate] = useState(false);

  useEffect(() => {
    // Check if user is navigating from the mentor search page
    if (animateOnEnter && typeof window !== 'undefined') {
      const fromSearch = sessionStorage.getItem('fromMentorSearch') === 'true';
      
      if (fromSearch) {
        setShouldAnimate(true);
        // Don't remove the flag immediately - let it persist for back button
        // It will be overwritten on next navigation
      }
    }
  }, [animateOnEnter]);

  // Use CSS class for gradient instead of inline styles
  const baseClass = isFullPage ? 'bg-theme-gradient' : 'gradient-header';

  // For profile page header - animate from full height to small slice when coming from search
  if (animateOnEnter && shouldAnimate) {
    return (
      <motion.div
        className={baseClass}
        initial={{ height: '100vh', position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}
        animate={{ height: 'auto', position: 'relative', zIndex: 'auto' }}
        transition={{
          duration: 0.6,
          ease: [0.4, 0, 0.2, 1],
        }}
      >
        {children}
      </motion.div>
    );
  }

  // Regular render without animation
  return (
    <div className={baseClass}>
      {children}
    </div>
  );
}
